"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleFields = void 0;
var React = require("react");
var LanguageSelect_1 = require("../../../LanguageSelect");
var TimezoneSelect_1 = require("../../../TimezoneSelect");
var LocaleFields = function (_a) {
    var localeData = _a.localeData, disabled = _a.disabled;
    return (React.createElement("div", { className: 'reports-modal-input-fields-container' },
        React.createElement("div", { className: 'reports-modal-input-field' },
            React.createElement(LanguageSelect_1.LanguageSelect, { value: localeData.language, onChange: localeData.setLanguage, labelClassName: "reports-modal-input-field-label", fieldClassName: "reports-modal-input-field-dropdown", isDisabled: disabled })),
        React.createElement("div", { className: 'reports-modal-input-field' },
            React.createElement(TimezoneSelect_1.TimezoneSelect, { value: localeData.timezone, onChange: localeData.setTimezone, labelClassName: "reports-modal-input-field-label", fieldClassName: "reports-modal-input-field-dropdown", isDisabled: disabled }))));
};
exports.LocaleFields = LocaleFields;
